module.exports = __webpack_public_path__ + "static/media/uy.4caed124.svg";